import extendTaskInstanceModel from '../model-extensions/extendTaskInstanceModel';
import { replaceArrayElement, uniq } from '../utils';

const TaskInstancesCache = {
  dict: null,
  byRangeDict: null,

  getInstancesByRange(range) {
    if (!this.byRangeDict) {
      return null;
    }
    return this.byRangeDict[range];
  },

  updateInstances(instances, range) {
    const extendedInstances = instances.map(extendTaskInstanceModel);
    if (!this.byRangeDict) {
      this.byRangeDict = {};
    }
    this.byRangeDict[range] = extendedInstances;

    if (!this.dict) {
      this.dict = {};
    }

    extendedInstances.forEach((instance) => {
      this.dict[instance.id] = instance;
    });
  },

  updateSingleInstance(instance) {
    const extendedInstance = extendTaskInstanceModel(instance);
    if (!this.dict) {
      this.dict = {};
    }
    this.dict[instance.id] = extendedInstance;
    this.updateInstanceInAllRanges(extendedInstance);
  },

  removeSingleInstance(instance) {
    if (this.dict[instance.id]) {
      delete this.dict[instance.id];
      this.deleteInstanceFromAllRanges(instance);
    }
  },

  updateInstanceInAllRanges(instance) {
    if (this.byRangeDict) {
      Object.entries(this.byRangeDict).forEach(([range, instances]) => {
        const index = instances.findIndex(({ id }) => id === instance.id);
        if (index > -1) {
          replaceArrayElement(this.byRangeDict[range], index, instance);
        }
      });
    }
  },

  deleteInstanceFromAllRanges(instance) {
    if (this.byRangeDict) {
      Object.entries(this.byRangeDict).forEach(([range, instances]) => {
        this.byRangeDict[range] = instances.filter(({ id }) => id !== instance.id);
      });
    }
  },

  isRangeCached(range) {
    return Boolean(range && this.byRangeDict?.[range]);
  },

  deleteInstancesByShiftId(shiftId) {
    if (this.byRangeDict) {
      let matchingInstances = [];
      Object.entries(this.byRangeDict).forEach(([, instances]) => {
        const matches = instances.filter(({ eventId }) => eventId === shiftId);
        matchingInstances = [...matchingInstances, ...matches];
      });
      uniq(matchingInstances, ({ id }) => id).forEach((instance) =>
        this.removeSingleInstance(instance)
      );
    }
  },

  clear() {
    this.dict = null;
    this.byRangeDict = null;
  },
};

export default TaskInstancesCache;
